module.exports = __webpack_public_path__ + "static/media/bs2.fe79df74.webp";